import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';

// Analytics
import mixpanel from 'mixpanel-browser';

// Redux
import { connect } from 'react-redux';

// Actions 
import { toggleSideNav } from '../actions/navActions';

// Components
import Backdrop from '../components/common/Backdrop';
import HelpSidebar from '../components/sidebar/HelpSidebar';
import Help_SidebarMobile from '../components/sidebar/Help_SidebarMobile';
import Help_Navbar from '../components/help_page/Help_Navbar';
import GettingStarted from '../components/help_page/GettingStarted';
import Configuration from '../components/help_page/Configuration';
import Undetectability from '../components/help_page/Undetectability';
import Cancel_Subscription from '../components/help_page/Cancel_Subscription';
import Refund_Policy from '../components/help_page/Refund';
import Out_Of_Credits from '../components/help_page/Out_Of_Credits';
import Cant_See_Screen from '../components/help_page/Cant_See_Screen';
import Shows_When_Sharing from '../components/help_page/Shows_When_Sharing';
import ContactUs from '../components/help_page/ContactUs'
  
const Help = ({
  nav: {
    sideNav
  },
  auth,
  toggleSideNav
}) =>  {

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  // Analytics 
  const [sentMixpanel, setSentMixpanel] = useState(false);
  
  useEffect(() => {
      
      // Add event listener for window resize
      window.addEventListener('resize', () => handleWindowSizeChange());

      // Cleanup the event listener when the component unmounts
      return () => window.removeEventListener('resize', () => handleWindowSizeChange());
  }, []);

  // Update window width state on window resize
  const handleWindowSizeChange = () => {
      setWindowWidth(window.innerWidth);
  };

  // Check if the device is mobile or tablet
  const isMobile = windowWidth <= 769;
  const isTablet = windowWidth <= 1024;

  // Get the current URL and extract the "filter" parameter
  const url_filter = (window.location.href);
  const url = new URL(url_filter);
  const filter = url.searchParams.get("section");

  let backdrop;

  // Create a backdrop component if the sideNav is open
  if (sideNav) {
      backdrop = <Backdrop click={toggleSideNav} />;
  }

  // Function to handle Mixpanel analytics
  const handleMixpanel = () => {
    mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN);
    mixpanel.track("Help Page View");
  }

  // Trigger Mixpanel analytics on initial render in production mode
  if(process.env.NODE_ENV === 'production' && !sentMixpanel) {
      handleMixpanel();
      setSentMixpanel(true);
  }

	return (
    <Fragment>
      {isMobile && <Help_Navbar />}

      <div className={sideNav ? "help_page open": "help_page"}>
        {isMobile ? <Help_SidebarMobile slideMenu={sideNav} handleSlideMenu={toggleSideNav} page_filter={filter} auth={auth} /> : <HelpSidebar page_filter={filter} auth={auth} />}

        <main style={{padding: `${isMobile ? '2rem .5rem' : '4rem 3rem'}`, maxWidth: '48rem', margin: '0 auto', width: '100%'}}>
          {(filter == null || filter == 'getting-started') && <GettingStarted isMobile={isMobile} />}
          {(filter == 'configuration') && <Configuration isMobile={isMobile} />}
          {(filter == 'undetectability') && <Undetectability isMobile={isMobile} />}
          {(filter == 'cancel-subscription') && <Cancel_Subscription isMobile={isMobile} />}
          {(filter == 'refund-policy') && <Refund_Policy isMobile={isMobile} />}
          {(filter == 'out-of-credits') && <Out_Of_Credits isMobile={isMobile} />}
          {(filter == 'cant-see-screen') && <Cant_See_Screen isMobile={isMobile} />}
          {(filter == 'shows-when-sharing') && <Shows_When_Sharing isMobile={isMobile} />}
          {(filter == 'contact') && <ContactUs isMobile={isMobile} />}
        </main>

        {backdrop}

      </div>
    </Fragment>
	);
  }
  
Help.propTypes = {
    nav: PropTypes.object.isRequired,
    auth: PropTypes.object.isRequired,
    toggleSideNav: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({
    nav: state.nav,
    auth: state.auth
})

export default connect(mapStateToProps, {
    
    // Connecting actions to the component
    toggleSideNav
})(Help);
  
  